import axios from 'axios';

export const state = {
  files: [],
  loading: false,
};

export const mutations = {
  setFiles(context, files) {
    context.files = files;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getFiles({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      commit('setLoading', true);
      const files = await axios.get(`${window.BASE_API.FINANCIAL_PRODUCT}/files?${query}`, options)
        .then(response => response);

      commit('setFiles', files.data ? files.data : []);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
  async previewFile(context, query) {
    const options = {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/pdf',
      },
    };

    return axios
      .get(`${window.BASE_API.FINANCIAL_PRODUCT}/files/preview?${query}`, options)
      .then(response => response.data);
  },
  async filesByCategory(context, query) {
    return axios
      .get(`${window.BASE_API.FINANCIAL_PRODUCT}/files?${query}`)
      .then(response => response.data);
  },
  async uploadFile(context, data) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/pdf',
      },
    };
    const fd = new FormData();
    fd.append('category', data.category);
    fd.append('title', data.title);
    fd.append('fileName', data.fileName);
    if (data.template) {
      fd.append('template', data.template);
    }
    if (data.data) {
      fd.append('data', data.data);
    }
    if (data.file) {
      fd.append('file', data.file);
    }
    if (data.created_at) {
      fd.append('created_at', data.created_at);
    }
    if (data.deleted_at) {
      fd.append('deleted_at', data.deleted_at);
    }
    if (data.dbEdit) {
      fd.append('dbEdit', data.dbEdit);

      return axios.put(`${window.BASE_API.FINANCIAL_PRODUCT}/files`, fd, options)
        .then(response => response)
        .catch(error => Promise.reject(error));
    }

    return axios.put(`${window.BASE_API.FINANCIAL_PRODUCT}/files`, fd, options)
      .then(response => response)
      .catch(error => Promise.reject(error));
  },
  async getFile(context, query) {
    return axios
      .get(`${window.BASE_API.FINANCIAL_PRODUCT}/files?${query}`)
      .then(response => response.data);
  },
  async deleteFile(context, query) {
    return axios
      .delete(`${window.BASE_API.FINANCIAL_PRODUCT}/files?${query}`)
      .catch(error => Promise.reject(error));
  },
};

const filesStore = {
  state,
  mutations,
  actions,
};

export default filesStore;



// WEBPACK FOOTER //
// ./src/store/financialProducts/filesStore.js